import { render } from "./LoaderView.vue?vue&type=template&id=1c389ee5&scoped=true&ts=true"
import script from "./LoaderView.vue?vue&type=script&lang=ts"
export * from "./LoaderView.vue?vue&type=script&lang=ts"

import "./LoaderView.vue?vue&type=style&index=0&id=1c389ee5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c389ee5"]])

export default __exports__